import { render, staticRenderFns } from "./shopcar.vue?vue&type=template&id=4c6f977f&scoped=true&"
import script from "./shopcar.vue?vue&type=script&lang=js&"
export * from "./shopcar.vue?vue&type=script&lang=js&"
import style0 from "./shopcar.vue?vue&type=style&index=0&id=4c6f977f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6f977f",
  null
  
)

export default component.exports